import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PublicFooter() {
  const [contact, setContact] = useState({ email: "hello@nexra.com" });
  const [footer, setFooter] = useState({ tagline: "Technology Delivery Services. AI-enabled by design." });

  useEffect(() => {
    let active = true;
    api.get("/content").then((r) => {
      if (!active) return;
      if (r.data?.content?.contact) setContact(r.data.content.contact);
      if (r.data?.content?.footer) setFooter(r.data.content.footer);
    }).catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <footer className="bg-obsidian text-white relative overflow-hidden" data-testid="public-footer">
      <div className="absolute inset-0 bg-gridlines-dark opacity-50 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-6">
            <div className="h-6 w-6 bg-execution" />
            <span className="font-heading text-xl font-bold tracking-tight">Nexra</span>
            <span className="ml-2 pl-3 border-l border-white/20 inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-[0.2em] text-white/60">
              <span className="status-dot" /> AI-Enabled Delivery
            </span>
          </div>
          <p className="font-heading text-2xl sm:text-3xl tracking-tight leading-tight max-w-md">
            {footer.tagline}
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Platform</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="text-white/70 hover:text-white transition-colors" data-testid="footer-services">Services</Link></li>
            <li><Link to="/service-models" className="text-white/70 hover:text-white transition-colors" data-testid="footer-models">Service Models</Link></li>
            <li><Link to="/ai-delivery" className="text-white/70 hover:text-white transition-colors" data-testid="footer-ai">AI in Delivery</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Engage</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/engage" className="text-white/70 hover:text-white transition-colors" data-testid="footer-engage">Engage Nexra</Link></li>
            <li><Link to="/join-network" className="text-white/70 hover:text-white transition-colors" data-testid="footer-network">Delivery Network</Link></li>
            <li><Link to="/contact" className="text-white/70 hover:text-white transition-colors" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Contact</div>
          <a
            href={`mailto:${contact.email}`}
            className="block font-heading text-xl lg:text-2xl tracking-tight hover:text-execution transition-colors duration-200 mb-4 break-all"
            data-testid="footer-email"
          >
            {contact.email}
          </a>
          <Link
            to="/engage"
            className="inline-flex items-center gap-2 border-b border-white/40 hover:border-execution hover:text-execution transition-colors pb-1 text-xs font-mono uppercase tracking-wider"
            data-testid="footer-cta"
          >
            Engage Nexra →
          </Link>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/50 font-mono uppercase tracking-wider">
            © {new Date().getFullYear()} Nexra — Technology Delivery Services
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="text-xs text-white/60 hover:text-white font-mono uppercase tracking-wider transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="text-xs text-white/40 hover:text-white/80 font-mono uppercase tracking-wider transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
